
import { Outlet } from 'react-router';

import { Header } from './Header';

import { Footer } from './Footer';

import { ScrollToTop } from './ScrollToTop';

import { CookieConsentBanner } from './CookieConsentBanner';

import { ContactWidget } from './ContactWidget';

import { AnnouncementBanner } from './AnnouncementBanner';

export function Layout() {

  return (

    <>

      <ScrollToTop />

      <AnnouncementBanner />

      <Header />

      <main>

        <Outlet />

      </main>

      <Footer />

      <ContactWidget />

      <CookieConsentBanner />

    </>

  );

}

